module.exports = __webpack_public_path__ + "media/images/new_home/community-bg-a3bd484ca5fb3a2fad9b3d2f721056a7.png";